import GameOptions from "../../../model/options/GameOptions";
import Page from "../../framework/Page";
import View from "../../framework/View";

export default class FpsThrottleSettingView extends View {
    /**
     * @abstract
     * @param {string} parentId
     * @param {string} elementId 
     * @param {GameOptions} gameOptions
     */
    constructor(parentId, elementId, gameOptions) {
        super(parentId, elementId);

        /**
         * @constant
         * @type {GameOptions}
         */
        this.gameOptions = gameOptions;

        /**
         * @type {HTMLElement}
         */
        this.mainElement = null;

        /**
         * @type {HTMLElement}
         */
        this.option15 = null;
        /**
         * @type {HTMLElement}
         */
        this.option30 = null;
        /**
         * @type {HTMLElement}
         */
        this.option60 = null;
        /**
         * @type {HTMLElement}
         */
        this.option120 = null;
        /**
         * @type {HTMLElement}
         */
        this.optionNone = null;

        /**
         * @type {number}
         */
        this.displayedMaxFps = -1000;
    }

    /**
     * @override
     */
    initializeView() {
        // The upgrade view is dynamically created.
        const id = this.getElementId();

        const parent = Page.getElement(this.parentId);
        if (!parent) {
            console.log('FpsThrottleSettingView.initializeView() No parent element found! parentId=' + this.parentId);
            return;
        }

        this.mainElement = Page.createElement('div', parent, id, 'settings-row-outer');

        const heading =  Page.createElement('div', this.mainElement, null, null);
        heading.innerHTML = 'FPS Throttle';

        const row1 = Page.createElement('div', this.mainElement, null, 'settings-row-fps-throttle');

        ////////////////////////////////////////////////////////
        // [15 FPS][30 FPS][60 FPS][120 FPS][UNLIMITED]
        ////////////////////////////////////////////////////////

        this.option15 = Page.createElement('div', row1, 'option15', 'settings-row-toggle-button');
        this.option15.innerHTML = '15';

        this.option30 = Page.createElement('div', row1, 'option30', 'settings-row-toggle-button');
        this.option30.innerHTML = '30';

        this.option60 = Page.createElement('div', row1, 'option60', 'settings-row-toggle-button');
        this.option60.innerHTML = '60';

        this.option120 = Page.createElement('div', row1, 'option120', 'settings-row-toggle-button');
        this.option120.innerHTML = '120';

        this.optionNone = Page.createElement('div', row1, 'optionNone', 'settings-row-toggle-button');
        this.optionNone.innerHTML = 'None';

        //////////////////////////////////////
        // Button Click
        //////////////////////////////////////

        const thisRef = this;
        this.option15.onclick = function() {
            thisRef.gameOptions.maxFps = 16;
        };
        this.option30.onclick = function() {
            thisRef.gameOptions.maxFps = 32;
        };
        this.option60.onclick = function() {
            thisRef.gameOptions.maxFps = 64;
        };
        this.option120.onclick = function() {
            thisRef.gameOptions.maxFps = 130;
        };
        this.optionNone.onclick = function() {
            thisRef.gameOptions.maxFps = -1;
        };

        super.initializeView();
    }

    /**
     * @override
     */
    updateViewContents() {
        const maxFps = this.gameOptions.maxFps;

        if (this.displayedMaxFps !== maxFps) {
            this.displayedMaxFps = maxFps;

            this.option15.className = maxFps === 16 ? 'settings-row-toggle-button-selected' : 'settings-row-toggle-button';
            this.option30.className = maxFps === 32 ? 'settings-row-toggle-button-selected' : 'settings-row-toggle-button';
            this.option60.className = maxFps === 64 ? 'settings-row-toggle-button-selected' : 'settings-row-toggle-button';
            this.option120.className = maxFps === 130 ? 'settings-row-toggle-button-selected' : 'settings-row-toggle-button';
            this.optionNone.className = maxFps === -1 ? 'settings-row-toggle-button-selected' : 'settings-row-toggle-button';
        }

        super.updateViewContents();
    }

}